<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<span>总览</span>
			</div>
			<div>
				<el-row :gutter="20">
					<el-col :span="6">
						<div class="grid-content" style="background-color: #409EFF;">
							<span class="iconfont icon--"></span>
							<div>
								<span>用户数</span>
								<span class="total-num">{{statistics.userCount}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content" style="background-color: #ff5c33;">
							<span class="iconfont icon-wodetiezi"></span>
							<div>
								<span>帖子数</span>
								<span class="total-num">{{statistics.postCount}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content" style="background-color: #4db8ff;">
							<span class="iconfont icon-huati"></span>
							<div>
								<span>话题数</span>
								<span class="total-num">{{statistics.disCount}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content" style="background-color: #8cd98c;">
							<span class="iconfont icon-pinglun"></span>
							<div>
								<span>评论数</span>
								<span class="total-num">{{statistics.commentCount}}</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div slot="header" class="clearfix">
				<span>用户统计</span>
			</div>
			<div>
				<el-row :gutter="20">
					<el-col :span="6">
						<div class="grid-content">
							<span class="iconfont icon--"></span>
							<div>
								<span style="color: #616161;">今日新增</span>
								<span style="color: #616161;font-size: 30px;" class="total-num">{{statistics.day}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content">
							<span class="iconfont icon-wodetiezi"></span>
							<div>
								<span style="color: #616161;">本周新增</span>
								<span style="color: #616161;font-size: 30px;" class="total-num">{{statistics.week}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content">
							<span class="iconfont icon-huati"></span>
							<div>
								<span style="color: #616161;">本月新增</span>
								<span style="color: #616161;font-size: 30px;" class="total-num">{{statistics.month}}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="grid-content">
							<span class="iconfont icon-huati"></span>
							<div>
								<span style="color: #616161;">上月新增</span>
								<span style="color: #616161;font-size: 30px;" class="total-num">{{statistics.last_month}}</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div slot="header" class="clearfix">
				<span>用户分析</span>
			</div>
			<div>
				<el-row :gutter="20">
					<el-col :span="24">
						<div id="main" style="width: 100%;height:400px;"></div>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div slot="header" class="clearfix">
				<span>用户属性</span>
			</div>
			<div>
				<el-row :gutter="20">
					<el-col :span="12">
						<div id="echartScroll" style="width: 50;height:400px;"></div>
					</el-col>
					<el-col :span="12">
						<!-- <div id="echartBar" style="width: 50;height:400px;"></div> -->
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div slot="header" class="clearfix">
				<span>城市分布</span>
			</div>
			<div>
				<el-row :gutter="20">
					<el-col :span="24">
						<div id="echartBar" style="width: 100;height:400px;"></div>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div slot="header" class="clearfix">
				<span>开发团队</span>
			</div>
			<div>
				<template>
					<el-table :data="developmentTeam" border :show-header="false" style="width: 100%">
						<el-table-column prop="name" label="" width="">
						</el-table-column>
						<el-table-column prop="value" label="" width="">
						</el-table-column>
					</el-table>
				</template>
			</div>
		</el-card>
	</div>
</template>

<script>
	var echarts = require('echarts');
	export default {
		data() {
			return {
				userInfo: "",
				developmentTeam: [{
						name: "版权所有",
						value: "云瞄圈子"
					}, {
						name: "开发团队",
						value: "云喵网络"
					},
					{
						name: "官网",
						value: "https://www.ymeoo.cn"
					}
				],
				statistics: {},
				sysInfo: {}
			}
		},
		created() {
			this.userInfo = this.$store.state.userInfo;
			this.getStatisticsInfo();
		},
		methods: {
			getStatisticsInfo() {
				this.$H.get("system/statistics").then(res => {
					this.statistics = res.result;
					this.createChartLine();
					this.createChartScroll();
					this.createChartBar();
				})
			},
			// 创建城市分布图
			createChartBar() {
				var myChart = echarts.init(document.getElementById('echartBar'));

				var option = {
					color: ['#07c160'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: this.statistics.user_city.lable,
						axisLabel: {
							formatter: function(value) {
								return value.split("").join("\n")
							}
						},
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '人数',
						type: 'bar',
						barWidth: '60%',
						data: this.statistics.user_city.value,
					}]

				};

				myChart.setOption(option);
			},
			// 创建统计饼图
			createChartScroll() {
				var myChart = echarts.init(document.getElementById('echartScroll'));

				var option = {
					title: {
						text: '性别分布',
						left: 'center'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						show: true,
						orient: 'vertical',
						left: '50', //图例距离左的距离
						y: 'top', //图例上下居中
					},
					series: [{
						name: '性别',
						type: 'pie',
						radius: ['50%', '70%'],
						data: this.statistics.user_gender,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};

				myChart.setOption(option);
			},
			// 创建统计折线图表
			createChartLine() {
				var myChart = echarts.init(document.getElementById('main'));

				// 指定图表的配置项和数据
				var option = {
					title: {
						text: '最近30天用户分析',
						left: 'center'
					},
					tooltip: {
						show: true,
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
						data: this.statistics["month_data"].lable
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '增长人数',
						type: 'line',
						symbol: 'circle', //折点设定为实心点
						symbolSize: 8, //设定实心点的大小
						itemStyle: {
							normal: {
								color: '#07c160',
								lineStyle: {
									color: '#07c160'
								}
							}
						},
						data: this.statistics["month_data"].value
					}]
				};

				myChart.setOption(option);
			}
		}
	}
</script>

<style>
	.grid-content {
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		color: #FFFFFF;
	}

	.grid-content .iconfont {
		font-size: 50px;
		margin-right: 30px;
	}

	.grid-content .total-num {
		margin-top: 5px;
		font-size: 20px;
		font-weight: bold;
		text-align: center;
	}

	.grid-content>div {
		display: flex;
		flex-direction: column;
	}
</style>
